import React, {FC} from "react";
import {numberWithSeparationThousands} from "src/utils/formatters";
import {LeadersItem} from "src/api/user";
import styles from './index.module.css';

interface Props {
    player: LeadersItem;
    isCurrentPlayer: boolean;
    avatar: string;
}
export const LeaderItem: FC<Props> = ({ player, isCurrentPlayer, avatar }) => {
    const rankStyle = player.rankingPlace <= 3 ? styles[`rank-${player.rankingPlace}`]: '';
    return (
        <div className={`${styles.leaderItem} ${isCurrentPlayer ? styles.leaderItem_current : '' }`}>
            <div>
                <div className={`${styles.rank} ${rankStyle}`}>
                    <div className={styles.rankValue}>
                        { player.rankingPlace > 10000 ? '10000+' : player.rankingPlace}
                    </div>
                </div>
            </div>
            <div className={styles.nameWrapper}>
                <div className={styles.avatar} style={{backgroundImage: `url("${avatar || ''}")`}}>
                    {avatar ? null : player.username[0]?.toUpperCase() || ''}
                </div>
                <div className={styles.name}>{player.username}</div>
            </div>
            <div className={styles.points}>{numberWithSeparationThousands(player.balance)}</div>
        </div>
    )
}